import type { CatalogueEntry } from "../types";
import imageDark from "../images/abs-boundaries.dark.webp";
import imageLight from "../images/abs-boundaries.light.webp";

export const entry: CatalogueEntry = {
  slug: "abs-asgs-2026-indigenous-structure",
  displayName: `ABS ASGS 2026 Indigenous Structure`,
  datasetProductCode: `ABS-ASGS-2026-INDIGENOUS-STRUCTURE`,
  subtitle: `Statistical geography for the Aboriginal and Torres Strait Islander population, part of the ASGS Edition 4.`,
  shortDescription: `ABS ASGS 2026 Indigenous Structure enables the publication and analysis of statistics for the Aboriginal and Torres Strait Islander population of Australia, as part of the 2026 edition of the Australian Statistical Geography Standard (ASGS) produced by the Australian Bureau of Statistics (ABS).
The structure has three nested levels:
-	Indigenous Locations (ILOC) — small communities, urban and rural, of around 90 people or more
-	Indigenous Areas (IARE) — medium-sized areas for more detailed statistics
-	Indigenous Regions (IREG) — large areas that enable highly detailed analysis`,
  metadata: {
    dateAdded: 1789430400000,
    dataType: ["Polygons"],
    theme: `Statistical Boundaries`,
    totalFeatureCount: 0,
    updateFrequency: `As Deemed Necessary`,
    license: `CC BY 4.0`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  comingSoon: true,
  productDescriptionLink: `https://geoscape-australia-docs-abs-boundaries-product-desc.readthedocs-hosted.com/en/stable/`,
  imageLight,
  imageDark,
  searchTags: `ABS ASGS Indigenous Structure ILOC IARE IREG Indigenous Locations Indigenous Areas Indigenous Regions Aboriginal Torres Strait Islander Census Demographic Study Statistical Boundaries Stats`,
  detail: () =>
    import("../details/abs-asgs-2026-indigenous-structure").then((m) => m.detail),
};

export default entry;
